import { FlashSale } from 'components/main-page/home-page/flash-sale/FlashSale'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_FLASH_SALE } from 'services/api-home-page/apiFlashSale'
import { Alert } from 'avo-ui'

const INITIAL_STATE = {
    is_show: false,
}

export const FlashSaleContainer = () => {
    const [flashSaleDetail, setFlashSaleDetail] = useState(INITIAL_STATE)
    const { fetching: getFlashSaleDetail, isLoading } = useFetch(API_FLASH_SALE.DETAIL)
    const { fetching: updateFlashSale, isLoading: isUpdating } = useFetch(API_FLASH_SALE.UPDATE)

    const onChangeForm = (item) => {
        setFlashSaleDetail(item)
    }

    const onSubmit = () => {
        updateFlashSale(flashSaleDetail).then(() => {
            return Alert({
                icon: 'success',
                title: 'Success',
                message: 'Flash Sale Updated !',
            })
        })
    }

    useEffect(() => {
        getFlashSaleDetail().then((response) => setFlashSaleDetail({ ...response?.data }))
    }, [])

    const props = {
        isShow: flashSaleDetail?.is_show,
        onChangeForm,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <FlashSale {...props} />
}
